import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';
import { MessageUtil } from '../helpers/messages';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private app:AppService){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     
      var allowedRoles = route.data.allowedRoles
      var hasAccess = this.hasAccess(allowedRoles)
  
      if(!hasAccess){
        this.app.logoutUser()
        this.app.snackBar.open("Access Denied, Contact Administrator!!!", 'Dismiss',{
          duration: MessageUtil.TIMEOUT_DURATION
        })
      }
  
      return hasAccess;
    }
  
    hasAccess(accessRole){
      let userRole = this.app.helperService.getRoleList()
      for (let i = 0; i < userRole.length; i++) {
        for (let o = 0; o < accessRole.length; o++) {
          if(userRole[i].name.trim()  ===  accessRole[o]){
            return true
          }
  
          if('Settings'  ===  accessRole[o]){
            return true
          }
        }
      }
    }
}
